// extracted by mini-css-extract-plugin
module.exports = {"parent":"Subscription_parent_2SRC6","algin_left":"Subscription_algin_left_2FQpy","planPC":"Subscription_planPC_3ICm0","planSP":"Subscription_planSP_wBgrv"};